/* global $, APP, AccessBellMeetJS, config, interfaceConfig */

import React from 'react';
import { Button, TextField } from '@material-ui/core';

import { AbstractWelcomePage, _mapStateToProps} from '../../../welcome/components/AbstractWelcomePage';

import { WaitingRoomHandIcon, WaitingRoomClockIcon } from '../../../base/icons/svg';

import { connect } from '../../../base/redux';
import { translate } from '../../../base/i18n';

import getRoomName from '../../../base/config/getRoomName';

// import socketIOClient from "socket.io-client";

import parseURLParams from '../../../base/config/parseURLParams';
// import DotLoader from "react-spinners/DotLoader";
// import { css } from "@emotion/core";
import baseApi from '../../../../../baseApiUrl';

class WaitingRoomConference extends AbstractWelcomePage {

    constructor(props) {
        super(props);
        this.state = {
            enteredName: window.participantName == undefined || window.participantName == "" ? false : true,
            tempFullName: window.participantName,
            room: getRoomName(),
            // socket: socketIOClient('https://abvideo.uc.r.appspot.com/', {transports: ['polling']}),
            fetchEndpoint:  `${baseApi}/`,
            admissionsInterval: null,
            loading: false
        }
    }

    async componentDidMount() {
            if(this.state.enteredName) {
                var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
            let urlGetParams = null;
            if (jsonContent != undefined && jsonContent != "") {
                urlGetParams = JSON.parse('{"' + jsonContent + '"}');
            }
            var memberId = urlGetParams['memberId'];
            var meetingId = window.location.pathname.substring(1);
            console.log(meetingId, memberId, this.state.tempFullName);
            var res = await fetch(this.state.fetchEndpoint + 'api/internal/prejoin_room', {
                method: "POST",
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "meeting_id": meetingId,
                    "member_id": memberId,
                    "name": this.state.tempFullName
                })
            }).then(res => res.json()).then((res) => {return res});
            var admissionsInterval = setInterval(this.pollForAdmissions.bind(this), 1000);
            this.setState({admissionsInterval: admissionsInterval});
        }
    }
    // componentDidMount() {
    //     var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
    //     let urlGetParams = null;
    //     if (jsonContent != undefined && jsonContent != "") {
    //         urlGetParams = JSON.parse('{"' + jsonContent + '"}');
    //     }
    //     var memberId = urlGetParams['memberId'];
    //     var meetingId = window.location.pathname.substring(1);
    //     this.state.socket.emit('join_room', {
    //         "meeting_id": meetingId,
    //         "member_id": memberId,
    //         "name": "Kamil Ali"
    //     });

    //     var boundedSocketResponseHandler = this._handleSocketResponse.bind(this);

    //     this.state.socket.on('admitted', boundedSocketResponseHandler);
    //     window.onbeforeunload = () => {
    //         var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
    //         let urlGetParams = null;
    //         if (jsonContent != undefined && jsonContent != "") {
    //             urlGetParams = JSON.parse('{"' + jsonContent + '"}');
    //         }
    //         var memberId = urlGetParams['memberId'];
    //         var meetingId = window.location.pathname.substring(1);
    //         console.log(memberId, meetingId);
    //         console.log("leaving room");
    //         this.state.socket.emit('leave_room', {
    //             "meeting_id": meetingId,
    //             "member_id": memberId
    //         });
    //     }
    // }

    async componentWillUnmount() {
        // this.state.socket.off('admitted')
        clearInterval(this.state.admissionsInterval);
        if(window.location.search.indexOf('?') != -1) {
            var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
            let urlGetParams = null;
            if (jsonContent != undefined && jsonContent != "") {
                urlGetParams = JSON.parse('{"' + jsonContent + '"}');
            }
            var memberId = urlGetParams['memberId'];
            var meetingId = window.location.pathname.substring(1);
            console.log(memberId, meetingId);
            console.log("leaving room");
            var res = await fetch(this.state.fetchEndpoint + '/api/internal/preleave_room', {
                method: "POST",
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "meeting_id": meetingId,
                    "member_id": memberId
                })
            }).then(res => res.json()).then((res) => {return res});
            // this.state.socket.emit('leave_room', {
            //     "meeting_id": meetingId,
            //     "member_id": memberId,
            //     "members": res['members']
            // });
        }
    }

    _handleSocketResponse(message) {
        console.log("Message:", message);
        let waitingHash = message['waiting_hash'];
        if (waitingHash == undefined) waitingHash = "-1";
        this._onJoinWithParams("&waitingHash=" + waitingHash);
    }

    _handlePollingResponse(waitingHash) {
        clearInterval(this.state.admissionsInterval);
        if (waitingHash == undefined) waitingHash = "-1";
        this._onJoinWithParams("&waitingHash=" + waitingHash);
    }

    async pollForAdmissions() {
        //console.log("Polling for admissions...");
        var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
        let urlGetParams = null;
        if (jsonContent != undefined && jsonContent != "") {
            urlGetParams = JSON.parse('{"' + jsonContent + '"}');
        }
        var memberId = urlGetParams['memberId'];
        var meetingId = window.location.pathname.substring(1);

        var res = await fetch(this.state.fetchEndpoint + 'api/internal/admissions', {
            method: "POST",
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "member_id": memberId,
                "meeting_id": meetingId
            })
        }).then(res => res.json()).then((res) => {return res});
        console.log("result here", res);
        console.log("polling from here",res['admitted_status']);
        if(res['admitted_status'] != "pending") {
            console.log("it got in here");
            this._handlePollingResponse(res['waiting_hash']);
        }
    }

    async _handleSetName() {
        this.setState({loading: true});
        var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
        let urlGetParams = null;
        if (jsonContent != undefined && jsonContent != "") {
            urlGetParams = JSON.parse('{"' + jsonContent + '"}');
        }
        var memberId = urlGetParams['memberId'];
        var meetingId = window.location.pathname.substring(1);
        var res = await fetch(this.state.fetchEndpoint + 'api/internal/prejoin_room', {
            method: "POST",
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "meeting_id": meetingId,
                "member_id": memberId,
                "name": this.state.tempFullName
            })
        }).then(res => {console.log(res); return res.json()}).then((res) => {return res});
        var admissionsInterval = setInterval(this.pollForAdmissions.bind(this), 1000);
        this.setState({admissionsInterval: admissionsInterval});
        localStorage.setItem("enteredName", this.state.tempFullName);
        window.enteredParticipantName = this.state.tempFullName;
        // this.state.socket.emit('join_room', {
        //     "meeting_id": meetingId,
        //     "member_id": memberId,
        //     "members": res['members']
        // });

        // var boundedSocketResponseHandler = this._handleSocketResponse.bind(this);

        // this.state.socket.on('admitted', boundedSocketResponseHandler);
        // window.onbeforeunload = () => {
        //     var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
        //     let urlGetParams = null;
        //     if (jsonContent != undefined && jsonContent != "") {
        //         urlGetParams = JSON.parse('{"' + jsonContent + '"}');
        //     }
        //     var memberId = urlGetParams['memberId'];
        //     var meetingId = window.location.pathname.substring(1);
        //     console.log(memberId, meetingId);
        //     console.log("leaving room");
        //     var res = await fetch(this.state.fetchEndpoint + '/api/internal/preleave_room', {
        //         method: "POST",
        //         mode: 'cors',
        //         cache: 'no-cache',
        //         headers: {
        //             'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify({
        //             data: {
        //                 "meeting_id": meetingId,
        //                 "member_id": memberId
        //             }
        //         })
        //     }).then(res => res.json()).then((res) => {return res});
        //     if(res['members'] != undefined && res['members'] != "None") {
        //         this.state.socket.emit('leave_room', {
        //             "meeting_id": meetingId,
        //             "member_id": memberId,
        //             "members": res['members']
        //         });
        //     }
        // }
        this.setState({
            enteredName: true
        });
    }

    async _handleExitRoom() {
        var jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
        let urlGetParams = null;
        if (jsonContent != undefined && jsonContent != "") {
            urlGetParams = JSON.parse('{"' + jsonContent + '"}');
        }
        var memberId = urlGetParams['memberId'];
        var meetingId = window.location.pathname.substring(1);
        console.log(memberId, meetingId);
        console.log("leaving room");
        var res = await fetch(this.state.fetchEndpoint + '/api/internal/preleave_room', {
            method: "POST",
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "meeting_id": meetingId,
                "member_id": memberId
            })
        }).then(res => res.json()).then((res) => {return res});
        // this.state.socket.emit('leave_room', {
        //     "meeting_id": meetingId,
        //     "member_id": memberId,
        //     "members": res['members']
        // });
        clearInterval(this.state.admissionsInterval);
        window.location.href = "/";
    }

    render() {
        if(this.state.enteredName) {
            return (
                <div style={{height: '100%', overflowY: 'scroll'}}>
                <div className = "inlay" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <div style={{display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: '200px'}}>
                        <WaitingRoomHandIcon />
                    </div>
                    <h3 className = 'inlay__title' style={{marginTop: "150px"}}>
                    You have entered a waiting room. Please wait till you are invited in.
                    </h3>
                    {/* <Button variant="contained" color="primary" onClick={this._handleExitRoom.bind(this)} style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%"}}>
                        Exit
                    </Button> */}
                </div>
                </div>
            )
        } else {
            return (
                <div>
                {!this.state.loading && <div className = "inlay" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <div style={{display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: '200px'}}>
                        <WaitingRoomHandIcon />
                    </div>
                    <h3 className = 'inlay__title' style={{marginTop: "125px"}}>
                        Please enter your name to enter the waiting room.
                    </h3>
                    <TextField
                        id="full-name"
                        label="Full Name"
                        value={this.state.tempFullName}
                        onChange={(event) => this.setState({tempFullName: event.target.value})}
                        variant="filled"
                        style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%", borderRadius: 5, backgroundColor: "white"}}
                    />
                    <Button variant="contained" color="primary" onClick={this._handleSetName.bind(this)} style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%"}}>
                        Enter Waiting Room
                    </Button>
                </div>
                }
            </div>             )
        }
    }
}

export default translate(connect(_mapStateToProps)(WaitingRoomConference));